const questionModule = {
  title: "로그인 도움말",
  question1: "아이디와 로그인 비밀번호를 잊어버렸는데 어떻게 해야 합니까?",
  answer1:
    "*을 클릭하여 신분증이 통과되면 새로운 로그인 비밀번호를 설정할 수 있습니다.",
  question2: "등록된 핸드폰 번호가 사용되지 않으면 어떻게 해야 합니까?",
  answer2: "페이지 하단의 * 를 클릭하여 Paymul 사무국으로 연락하세요.",
  kefu: "관련된 문제를 못 찾았습니까?클릭*",
  linkKefu: "고객 상담",
  returnPassword: "비밀번호 찾기",
  help1: "정상적으로 로그인할 수 없다.",
  helpContent1: `Paymul에 로그인 시 이용약관 및 개인정보취급규범을 확인하시고 등록 시 휴대폰번호와 비밀번호를 입력하여 로그인 한다.신규 가입자는 SMS 문자 메시지를 받을 수 있는 휴대폰으로 가입을 해야 한다.비밀번호를 잊으셨다면, 로그인 「비밀번호 잊기」를 클릭하고, 핸드폰 번호를 입력하여 비밀번호를 재설정한다.<br/>
   ※입력창 끝에 빈칸이 있으면 로그인이 되지 않을 수 있다.<br/>
   ※그래도 해결되지 않을 경우 「문의」한다.`,
  help2: "배송지 설정은 어떻게 하는가?",
  helpContent2: `등록이 완료되면 사용자의 소재지가 자동으로 설정된다.위치 지정이 정확하지 않을 경우 수동으로 설정할 수도 있다.접속 후 배송지 수정을 원하면 「나의」→「나의 주소」에서 수정할 수 있다.`,
  help3: "어떤 지불 방법을 지원하는가？",
  helpContent3:
    "가게에 따라 달라진다.원하는 가게를 클릭하면 가게 내역에 해당 가게가 지원하는 결제 방법이 나와 있다.또한「검색」에서  지불 방법에 따라 가게 선정이 가능한다.",
  help4: "App의 언어를 바꾸고 싶다.",
  helpContent4:
    "접속 후 홈페이지 오른쪽 상단에 있는 지구 아이콘을 클릭하면 언어를 바꿀 수 있다.",
  help5: "가게명 검색 후 공백이 나타난다.",
  helpContent5:
    "사용자가 검색 중인 가게는 아직 페이물 가맹점이 되지 않았다.당사는 가맹점 규모를 확대하여 가맹의사가 있으면 문의주시기 바란다.가맹 신청은 <a href='info@127jp.com'>info@127jp.com</a>으로 문의한다.",
  help6: "예전에 갔던 가게도 다시 가고 싶었는데 가게 이름을 잊어버렸다.",
  helpContent6: `이용자는 한 매장에서 물건을 구매한 후 주문 내 가게 정보를 확인할 수 있다.또한 가게 페이지 오른쪽 상단에 있는 ♡를 클릭해 즐겨찾기에 추가할 수 있다.
  이후 「나의 저장」에서는 저장한 가게를 볼 수 있다.`,
  help7: "배송된 상품이 실제 주문과 일치하지 않음/상품 미배송",
  helpContent7: `해당 매장으로 직접 연락한다.<br/>
  ※가게 내역의 오른쪽 상단에 있는 전화 버튼을 클릭하여 가게와 전화통화를 할 수 있다.`,
  help8: "주문을 취소하고 싶다.",
  helpContent8: `해당 가게으로 직접 연락한다.가게 상세 오른쪽 상단에 있는 전화 버튼을 클릭하여 점포와 전화통화를 할 수 있다.<br/>
  ※특정가게 또는 운송시 주문취소가 되지 않을 수 있다.`,
  help9: "배송 도착 시 본인이 부재중이다.",
  helpContent9: "가게 내역 오른쪽 상단 클릭전화 버튼으로 가게와 직접 연락한다.",
  help10: "주문의 구체적인 절차는.",
  helpContent10: `１）가게 페이지를 연 후, 「배달」 「셀프서비스」 「온라인판매」를 선택하여 주문할 수 있다.<br/>
  ２）주문 후 주문내역 페이지에서 주문 상태를 볼 수 있다.「확인됨」이라고 하는 것은, 가게에서 주문을 받았으며, 음식을 준비하고 있음을 나타난다.<br/>
  가게가 음식을 준비하고 배달원에게 인도한 후에 주문 상태는 "배달중"이 된다.<br/>
  ４）주문서 배달이 완료되면 주문내역 페이지 하단에「수령확인」버튼이 나타난다.버튼이 표시되지 않으면 페이지를 다시 로딩한다.<br/>
  ５）이용자가 상품을 확인하고「수령확인」버튼을 클릭하면 주문이 완료되고, 입점자가 입금 확인을 하는 절차다.<br/>
  ６）가게의 입금 확인 후 이용자는 주문내역 페이지에서 리뷰를 할 수 있다.`
};

export default questionModule;
